export function safeJSONParse(str: string | null | undefined) {
	if (str) {
		try {
			return JSON.parse(str);
		} catch {}
	}
	return null;
}

export async function safeResponseJSON(response: Response) {
	if (response) {
		try {
			return await response.json();
		} catch {}
	}
	return null;
}
